import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { fetchResetPasword } from '../../redux/slices/resetPasswordSlice';

const ForgotPasswordComponent = () => {
    const dispatch = useDispatch();

    const handleForgotPassword = async (formData) => {
        try {
            const resetPass = await dispatch(fetchResetPasword({ mail: formData.mail }));

            if (resetPass.payload) {
                const data = resetPass.payload;
                if (data.statusCode === 200) {
                    toast.success(`${data.message}`);
                } else {
                    toast.error(`${data.message}`);
                }
            }
        } catch (error) {
            toast.error('Giriş işlemi sırasında bir hata oluştu');
        }
    }

    return handleForgotPassword
}

export default ForgotPasswordComponent
